import { ReactComponent as SplitIcon } from 'assets/icons/git-branch.svg'
import ActionButton from 'components/ActionButton'
import IconWrapper from 'components/IconWrapper'
import SplitOrderModal from 'modals/SplitOrderModal'
import { useModalContext } from 'providers/Overlays/ModalProvider'
import { bodyPrimaryColor } from 'styles/styleVariables'
import type { Order } from 'types'

type SplitOrderButtonProps = { order: Order; disabled?: boolean }

const SplitOrderButton = ({ order, disabled }: SplitOrderButtonProps): JSX.Element => {
  const { showModal } = useModalContext()

  return (
    <ActionButton
      data-testid="SplitOrder"
      icon={
        <IconWrapper>
          <SplitIcon fill={bodyPrimaryColor} />
        </IconWrapper>
      }
      onClick={() => showModal(() => <SplitOrderModal order={order} />)}
      label="Split"
      hotKey="as"
      hotKeyLabel="a-s"
      disabled={disabled}
    />
  )
}

export default SplitOrderButton
